import { MONTH_DICT } from '@/consts';

export const convertDates = (startDate: string, endDate: string) => {
    const dates = [...new Set([startDate, endDate])];
    const dateString = dates.map((date) =>
        date
            .split('.')
            .map((item, i) => (i === 1 ? MONTH_DICT[Number(item.replace(/^0/, '')) as keyof typeof MONTH_DICT] : item)),
    );

    const isSameYear = [...new Set(dateString.map(([, , year]) => year))].length === 1;
    const daysPart = dateString.map(([day]) => day.replace(/^0/, '')).join('-');
    let monthPart = (
        isSameYear ? [...new Set(dateString.map(([, month]) => month))] : dateString.map(([, month]) => month)
    )
        .join(' / ')
        .trim();

    if (isSameYear) {
        monthPart += ` ${dateString[0][2]}`;
    } else {
        monthPart = monthPart
            .split('/')
            .map((str, i) => `${str} ${dateString[i][2]}`)
            .join(' / ');
    }

    return { days: daysPart, rest: monthPart };
};
